import { useQuery } from 'react-query';
import {
  IDataSubjectRightLookups,
  IMappedDataSubjectRightLookups,
} from '@interfaces/DataSubjectRightLookups.interface';
import { dataSubjectRight } from '../DataSubjectRight';

export function useDataSubjectRightLookups() {
  return useQuery(
    ['DataSubjectLookups'],
    async () => {
      const { data: authData } = await dataSubjectRight.getAccessToken();
      const { data } = await dataSubjectRight.getDataSubjectLookups(authData.access_token);
      return mapLookupData(data);
    },
    {
      refetchOnMount: false,
      staleTime: 100000,
      cacheTime: 100000,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
}

const mapLookupData = (data: IDataSubjectRightLookups): IMappedDataSubjectRightLookups => {
  return {
    DSR_OWN: data.DSR_OWN
      ? data.DSR_OWN.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
    DSR_RELATIONSHIP: data.DSR_RELATIONSHIP
      ? data.DSR_RELATIONSHIP.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
    RECEIVE_INFO: data.RECEIVE_INFO
      ? data.RECEIVE_INFO.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
    RELATIONSHIP_WITH_TAWAL: data.RELATIONSHIP_WITH_TAWAL
      ? data.RELATIONSHIP_WITH_TAWAL.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
    USER_VERIFICATION: data.USER_VERIFICATION
      ? data.USER_VERIFICATION.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
    REQUEST_TYPE: data.REQUEST_TYPE
      ? data.REQUEST_TYPE.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
    LOCATION: data.LOCATION
      ? data.LOCATION.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
    DSR_NATIONALITY: data.DSR_NATIONALITY
      ? data.DSR_NATIONALITY.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
  };
};
